import axios from 'axios';
import { loadEntity } from '@/helpers/utility';

const state = {
    byId: {},
    byProductId: {},
};

const getters = {
    orderItemsForProductId: (state) => ({ productId }) => {
        let ids = state.byProductId[productId] || [];
        return ids.map(id => state.byId[id])
            .filter(orderItem => orderItem);
    },
    orderItemsForProductAndVendorIds: (state, getters, rootState) => ({ productId, vendorId, showOtherVendorsInstead }) => {
        return getters.orderItemsForProductId({ productId })
            .filter(orderItem => orderItem.order_id
                && rootState.data.orders.byId[orderItem.order_id]
                && (
                    (!showOtherVendorsInstead && rootState.data.orders.byId[orderItem.order_id].vendor_id === vendorId)
                    || (showOtherVendorsInstead && rootState.data.orders.byId[orderItem.order_id].vendor_id !== vendorId)
                ));
    },
};

const actions = {
    async getOrderItems(context, { productId }) {
        let response = await axios.get(`/api/orderitems`, { params: { productId } });
        return loadEntity({ orderItems: response.data.data });
    },
    async getOrderItem(context, { id }) {
        let response = await axios.get(`/api/orderitems/${id}`);
        return loadEntity({ orderItem: response.data.data });
    },
    async createOrderItem({ commit }, { inventoryItemId, productId, orderItem }) {
        let response = await axios.post(`/api/inventoryitems/${inventoryItemId}/orderitems`, orderItem);
        orderItem = response.data.data;
        commit('ADD_PRODUCT_ORDER_ITEM_ID', { productId, orderItemId: orderItem.id });
        return loadEntity({ orderItem });
    },
    async updateOrderItem(context, { orderItem }) {
        let response = await axios.patch(`/api/orderitems/${orderItem.id}`, orderItem);
        return loadEntity({ orderItem: response.data.data });
    },
    async getOrderItemsForInventoryItem({ commit }, { inventoryItemId, productId }) {
        let response = await axios.get(`/api/inventoryitems/${inventoryItemId}/orderitems`);
        let orderItems = response.data.data;
        let result = loadEntity({ orderItems });
        commit('UPDATE_PRODUCT_ORDER_ITEM_IDS', { productId, orderItems });
        return result;
    },
    async deleteOrderItem({ commit }, { orderItem }) {
        let response = await axios.delete(`/api/orderitems/${orderItem.id}`);
        commit('DELETE_ORDER_ITEM', { response: response.data });
    },

    sideloadProductOrderItems({ commit }, { productId, orderItems }) {
        loadEntity({ orderItems });
        commit('UPDATE_PRODUCT_ORDER_ITEM_IDS', { productId, orderItems });
    },
};

const mutations = {
    LOAD_ENTITIES(state, { orderItems }) {
        if (orderItems)
            Object.values(orderItems).forEach(orderItem => Vue.set(state.byId, orderItem.id, orderItem));
    },
    DELETE_ORDER_ITEM(state, { response }) {
        Vue.delete(state.byId, response.id);
    },
    UPDATE_PRODUCT_ORDER_ITEM_IDS(state, { productId, orderItems }) {
        Vue.set(state.byProductId, productId, orderItems.map(i => i.id));
    },
    ADD_PRODUCT_ORDER_ITEM_ID(state, { productId, orderItemId }) {
        if (!state.byProductId[productId])
            Vue.set(state.byProductId, productId, []);

        if (!state.byProductId[productId].includes(orderItemId))
            state.byProductId[productId].push(orderItemId);
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
